/* Lightweight brand mark used in pre-auth and chrome surfaces.
 * Two variants ship out of /public with fully transparent backgrounds:
 *   - blue  (default) — dark blue wordmark + gold mark, for LIGHT surfaces
 *   - white           — white wordmark + gold mark,     for DARK surfaces
 *
 * There is no surrounding square/card — the PNG itself is transparent so it
 * blends into whatever section colour it sits on.
 *
 * For dynamic per-tenant branding inside the app, components should still
 * read from `settings.company_logo`.
 */

/* Natural aspect ratio of the packaged logos (both ~1500 x ~824). */
const LOGO_ASPECT = 1500 / 824;

const VARIANT_SRC = {
    blue: "/lokdhara-logo.png",
    white: "/lokdhara-logo-white.png",
};

export function BrandMark({ size = 36, variant = "blue", className = "" }) {
    // `size` is treated as the desired HEIGHT so the wordmark stays legible;
    // width is derived from the natural aspect ratio (no crop, no square box).
    const height = size;
    const width = Math.round(height * LOGO_ASPECT);
    const src = VARIANT_SRC[variant] || VARIANT_SRC.blue;
    return (
        <img
            src={src}
            alt="Lokdhara Microfinance"
            width={width}
            height={height}
            className={`object-contain ${className}`}
            style={{ height, width, background: "transparent" }}
        />
    );
}

export const BRAND_NAME = "Lokdhara Microfinance";
export const BRAND_SHORT = "Lokdhara";
export const BRAND_LOGO_URL = "/lokdhara-logo.png";
export const BRAND_LOGO_WHITE_URL = "/lokdhara-logo-white.png";
